export default {
  modelName: 'topic',
  label: '文案主題',
  fields: {
    sequence: {
      type: 'text',
      label: '排序',
      maxlength:10
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 30,
        },
      },
    },
    value: {
      type: 'text',
      label: '代號',
      rules: 'required',
      maxlength:10
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
}